import { define } from 'wicked-elements'

define('[data-component~="footnotes"]', {
  init() {
    this.$notes = [...this.element.querySelectorAll('[id^="fn"]')];
    this.$notes.forEach(this.formatNote)
  },
  formatNote($note) {
    const ref = $note.id.replace('fn-', 'fnref-')
    const jumpLink = ` <a href="#${ref}" class="!no-underline">⬏</a>`
    $note.lastElementChild.innerHTML = $note.lastElementChild.innerHTML + jumpLink
  },
})
